import CryptoJS from 'crypto-js';
// import JSEncrypt from './jsencrypt.js';
import { JSEncrypt } from 'jsencrypt'
import { sm2, sm4 } from 'sm-crypto'


let aesPublicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCGXsxHtxVl/rcvs4ezSOlfAOswLv1vlx6TQxyR3DOaQ2Fi0C4UvtdVX3mqjzhtjqaWIFlgq5C4BrjArFzCA0HR+FOFDxsnKSKimv3k2gaYCWgbOAQLShmfe5SfYEbziUOyxyM6CAJvDujLAAWzfyUo1XTQUFFgP5tvD6CIwIZ4OwIDAQAB";
let sm4PublicKey = "0403338970d472e601cea8b2666e50c3f1d6c887b0b4373d1db01380910be420a06cacd3f9d9f9293d1b527390d2226c7bb31462f7c129147ee421743d34c48e5d"
const ENV_DATA = process.env.VUE_APP_ENV_DATA
let method = 'AES'

if( ENV_DATA ){
    const envDate = JSON.parse(ENV_DATA)
    method = envDate.secretMethod
    sm4PublicKey = envDate.publicKey
}

const isSM4 = method === 'SM4'

var randomEle = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"]
//生成随机16位AES秘钥
function getRandomPrivateKey() {
    let pvaKey = ""
    for (let i = 0; i < 16; i++) {
        pvaKey = pvaKey + randomEle[parseInt(Math.random() * (14 + 1), 10)]
    }
    return pvaKey
}

function stringToHex(str){  
    let val="";  
    for(let i = 0; i < str.length; i++){  
        if(val == "")  
            val = str.charCodeAt(i).toString(16);  
        else  
            val += str.charCodeAt(i).toString(16);  
    }  
    return val;  
}

//RES公钥加密
function getAesKey(key) {
    var je = new JSEncrypt();
    je.setPublicKey(aesPublicKey);
    return je.encrypt(key);
}

//SM2 公钥加密
function getAesKeySM2(key) {
    const cipherMode = 0  // 1 - C1C3C2，0 - C1C2C3，默认为1
    const encryptData2 = "04" + sm2.doEncrypt(key, sm4PublicKey, cipherMode) 
    return encryptData2
}



//AES解密方法
function Decrypt(word,key) {
    var decrypt = CryptoJS.AES.decrypt(word, CryptoJS.enc.Utf8.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

// SM4 解密
function DecryptSM4(word,key) {
    const decryptData = sm4.decrypt(word, stringToHex(key)) 
    return decryptData
}



//AES加密方法
function Encrypt(word, key) {
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, CryptoJS.enc.Utf8.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

// SM4 加密
function EncryptSM4(word, key){
    const encryptData4 = sm4.encrypt(word, stringToHex(key))
    return encryptData4
}


export default {
    privateKey: getRandomPrivateKey(),
    Decrypt: isSM4 ? DecryptSM4 : Decrypt ,
    Encrypt: isSM4 ? EncryptSM4 : Encrypt,
    getAesKey: isSM4 ? getAesKeySM2 : getAesKey,
    getRandomPrivateKey,
}